var map = {
	"./Server-Busy.None.svg": 2310,
	"./Server-Busy.OfflineDrop.svg": 2311,
	"./Server-Busy.Ssh.svg": 2312,
	"./Server-Busy.TentacleActive.svg": 2313,
	"./Server-Busy.TentaclePassive.svg": 2314,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2315,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2316,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2317,
	"./Server-Default.AzureCloudService.svg": 2318,
	"./Server-Default.AzureServiceFabricCluster.svg": 2319,
	"./Server-Default.AzureSubscription.svg": 2320,
	"./Server-Default.AzureWebApp.svg": 2321,
	"./Server-Default.Ftp.svg": 2322,
	"./Server-Default.Kubernetes.svg": 2323,
	"./Server-Default.None.svg": 2324,
	"./Server-Default.OfflineDrop.svg": 2325,
	"./Server-Default.Ssh.svg": 2326,
	"./Server-Default.TentacleActive.svg": 2327,
	"./Server-Default.TentaclePassive.svg": 2328,
	"./Server-Disabled.AzureCloudService.svg": 2329,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2330,
	"./Server-Disabled.AzureSubscription.svg": 2331,
	"./Server-Disabled.AzureWebApp.svg": 2332,
	"./Server-Disabled.Ftp.svg": 2333,
	"./Server-Disabled.Kubernetes.svg": 2334,
	"./Server-Disabled.None.svg": 2335,
	"./Server-Disabled.OfflineDrop.svg": 2336,
	"./Server-Disabled.Ssh.svg": 2337,
	"./Server-Disabled.TentacleActive.svg": 2338,
	"./Server-Disabled.TentaclePassive.svg": 2339,
	"./Server-HasWarnings.Ssh.svg": 2340,
	"./Server-HasWarnings.TentacleActive.svg": 2341,
	"./Server-HasWarnings.TentaclePassive.svg": 2342,
	"./Server-Healthy.AzureCloudService.svg": 2343,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 2344,
	"./Server-Healthy.AzureSubscription.svg": 2345,
	"./Server-Healthy.AzureWebApp.svg": 2346,
	"./Server-Healthy.Ftp.svg": 2347,
	"./Server-Healthy.Kubernetes.svg": 2348,
	"./Server-Healthy.None.svg": 2349,
	"./Server-Healthy.OfflineDrop.svg": 2350,
	"./Server-Healthy.Ssh.svg": 2351,
	"./Server-Healthy.TentacleActive.svg": 2352,
	"./Server-Healthy.TentaclePassive.svg": 2353,
	"./Server-NeedsUpgrade.TentacleActive.svg": 2354,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 2355,
	"./Server-Unavailable.AzureCloudService.svg": 2356,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 2357,
	"./Server-Unavailable.AzureSubscription.svg": 2358,
	"./Server-Unavailable.AzureWebApp.svg": 2359,
	"./Server-Unavailable.Ftp.svg": 2360,
	"./Server-Unavailable.Kubernetes.svg": 2361,
	"./Server-Unavailable.OfflineDrop.svg": 2362,
	"./Server-Unavailable.Ssh.svg": 2363,
	"./Server-Unavailable.TentacleActive.svg": 2364,
	"./Server-Unavailable.TentaclePassive.svg": 2365,
	"./Server-Unhealthy.AzureCloudService.svg": 2366,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 2367,
	"./Server-Unhealthy.AzureWebApp.svg": 2368,
	"./Server-Unhealthy.Kubernetes.svg": 2369,
	"./Server-Unhealthy.OfflineDrop.svg": 2370,
	"./Server-Unhealthy.Ssh.svg": 2371,
	"./Server-Unhealthy.TentacleActive.svg": 2372,
	"./Server-Unhealthy.TentaclePassive.svg": 2373,
	"./Server-Unknown.AzureCloudService.svg": 2374,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 2375,
	"./Server-Unknown.AzureSubscription.svg": 2376,
	"./Server-Unknown.AzureWebApp.svg": 2377,
	"./Server-Unknown.Ftp.svg": 2378,
	"./Server-Unknown.Kubernetes.svg": 2379,
	"./Server-Unknown.None.svg": 2380,
	"./Server-Unknown.OfflineDrop.svg": 2381,
	"./Server-Unknown.Ssh.svg": 2382,
	"./Server-Unknown.TentacleActive.svg": 2383,
	"./Server-Unknown.TentaclePassive.svg": 2384,
	"./Server-Warning.OfflineDrop.svg": 2385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2309;